<!--
 * @Descripttion: 插槽属性设置
 * @Author: zenghua.wang
 * @Date: 2021-12-14 10:55:15
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-15 18:07:39
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 插槽设置 -->
    <el-collapse-item title="插槽设置">
      <el-form-item label="隐藏">
        <el-switch
          v-model="data.option.hide"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="插槽名">
        <el-input
          v-model="data.option.slotName"
          clearable
          placeholder="如：slot-abc"
        />
        <div class="xa-form-tips">插槽使用字母、数字、中划线命名</div>
      </el-form-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { theme, component } from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'

export default {
  name: 'config-slot',
  components: {
    configBase
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      component: component
    }
  }
}
</script>
